module.exports = __webpack_public_path__ + "img/null.91c64165.png";